import classNames from 'classnames';
import React from 'react';
import { inforBlackIcon, closeGreyLightIcon } from './assets';
import style from './style.module.scss';
import type { IProps } from './types';

export const InfoMessage = ({
  hasBackground,
  className,
  hasIcon,
  icon,
  infoMessage,
  isCloseButton = false,
  onClick,
}: IProps): React.JSX.Element => (
  <div
    className={classNames(
      style.infoMessageWrapper,
      hasBackground ? style.hasBackgroundInfo : '',
      className,
    )}
  >
    {hasIcon && (
      <div className={style.infoMessageIconWrapper}>
        <img
          width={16}
          height={20}
          className={classNames(style.infoMessageIcon)}
          alt=""
          src={icon || inforBlackIcon}
        />
      </div>
    )}
    <p className={style.infoMessageText}>{infoMessage}</p>
    {isCloseButton && (
      <div className={style.infoMessageButton} onClick={onClick} aria-hidden>
        <img width={14} height={14} alt="" src={closeGreyLightIcon} />
      </div>
    )}
  </div>
);

export default InfoMessage;
